import { keyframes, styled } from "goober";
import type { StepTestDotStatus } from "../../shared/stepTests/freshness";

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.2; }
`;

const Dot = styled("span")`
  display: inline-block;
  flex: none;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--gray-400);

  &[data-status="passed"] {
    background: var(--green-600);
  }
  &[data-status="failed"] {
    background: var(--red-600);
  }
  &[data-status="running"] {
    background: var(--gray-600);
    animation: ${pulse} 1.1s ease-in-out infinite;
  }
`;

export function StepTestStatusDot({ status }: { status: StepTestDotStatus }) {
  return <Dot data-status={status} aria-label={status} />;
}
